import { configureStore } from '@reduxjs/toolkit';
import collegesReducer from './reducers/collegesReducer';
import usersReducer from './reducers/usersReducer';
import filesReducer from './reducers/filesReducer';
import dataSlice from './reducers/LegalInformationsReducer';

const store = configureStore({
  reducer: {
    colleges: collegesReducer,
    users: usersReducer,
    files: filesReducer,
    legalInformations:dataSlice
  },
});

export default store;
